import OverridePatientFormDialog from './OverridePatientFormDialog';

export default OverridePatientFormDialog;
